export default function setPostTitlesHeight() {
  const isPresent = document.querySelector(".post-title");
  if (!isPresent) {
    return;
  }

  if (window.matchMedia("(min-width: 600px)").matches) {
    const titles = document.querySelectorAll(".post-title");
    const heightsArray = [];

    titles.forEach((title) => {
      const height = title.offsetHeight;

      heightsArray.push(...[height]);
    });

    const highest = Math.max.apply(Math, heightsArray);

    titles.forEach((title) => {
      title.style.minHeight = `${highest}px`;
    });
  }
}
